import React, { useState, useMemo } from 'react'
import { Table, Spinner } from 'react-bootstrap'
import { inject, observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { StyledCard } from './StyledDetailCard'
import { t } from 'i18next'
import { formatedDate } from '../../../utils/formatedDate'
import styled from 'styled-components'
import InstanceDocuments from './InstanceDocuments'
import PerformMaintananceModal from './PerformMaintananceModal'
import { isEmptyGuid, emptyGuid } from '../../../utils/emptyGuid'
import { isEmptyDate } from '../../../utils/emptyDate'

import useReport from '../../../utils/hooks/useReport'
import PdfIcon from '../../../assets/icons/pdf.svg'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { SettingsIcon } from '../../Icons/SettingsIcon'
import CreateRFIDInstance from '../CreateRFIDInstance'
import { BiBarcodeReader } from 'react-icons/bi'
import { cloneDeep } from 'lodash'
import { Link } from 'react-router-dom'
import trash from '../../../assets/icons/trash.svg'

const StyledTr = styled.tr`
  td {
    vertical-align: middle;
  }
`
const PdfIconBtn = styled.span`
  background: url(${PdfIcon}) center center no-repeat;
  background-size: contain;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  vertical-align: middle;

  :hover {
    opacity: 0.8;
  }

  }
`
const StyledFlexWrapper = styled.div`
  display:flex;
  justify-content:space-between;
  align-items: left;
  width: 100%;
  .leftSide{
    display:flex;
    flex-basis:70%;
  }
  .rightSide{
    display: flex;
    justify-content: flex-end;
    flex-basis:30%;
  }
`
const StyledRemoveLink = styled(Link)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  color: #ff0000;
  background-color: #ffe5e5;
  border: 1px solid #ffb3b3;
  border-radius: 6px;
  padding: 8px 12px;
  text-decoration: none;
  font-size: 0.9em;

  &:hover {
    background-color: #ffd6d6;
    color: #bf0000;
  }

  &:after {
    content: '';
    width: 1em;
    height: 1.1em;
    display: inline-block;
    margin-left: 0.25em;
    top: -2px;
    position: relative;
    vertical-align: middle;
    background: url(${trash}) center center no-repeat;
    background-size: contain;
  }

  @media (max-width: 567px) {
    flex: 1 !important;
    width: 100% !important;
    // padding: 10px;
    white-space: nowrap;
  }
`
const InstancesTable = (props) => {
  const { t } = useTranslation()
  const {
    articleInstances,
    showRFIDCol,
    showSerialKeyCol,
    showBatchlKeyCol,
    showWashCol,
    showWashCyclesCol,
    showServiceCol,
    allowMaintenance,
    allowMaintenanceReport,
    allowRFIDNeutralization,
    handleRFIDNeutralization,
  } = props
  const { createReport, reportIsLoading } = useReport()
  const [performMaintananceModal, setPerformMaintananceModal] = useState(false)
  const [maintananceInstance, setMaintananceInstance] = useState(null)
  const [isRemoving, setIsRemoving] = useState(false)

  const loadPdf = (instanceId) => {
    createReport('reportName', APIEndpoints.maintenanceReport(instanceId), {})
  }
  const performMaintanance = (instance) => {
    setMaintananceInstance(instance)
    setPerformMaintananceModal(true)
  }
  const LastScan = ({ obj }) => {
    let scanDate = formatedDate(obj.lastScanDate)
    let scanComment = obj.lastScanComment
    return (
      <>
        <div>{scanDate}</div>
        <div>{scanComment}</div>
      </>
    )
  }
  const ServiceJob = ({ obj }) => {
    let nextDate = formatedDate(obj.nextServiceDate)
    let lastService = obj.lastService
    return (
      <>
        {lastService && <div>{lastService}</div>}
        {nextDate && <div>{`${t('inventory:nextService')}: ${nextDate}`}</div>}
      </>
    )
  }
  const performRFIDNeutralization = async (instance) => {
    const { rfid } = instance
    setIsRemoving(true)
    await handleRFIDNeutralization(rfid)
    setIsRemoving(false)
  }
  const showActionButtons = () => {
    return (showSerialKeyCol && (allowMaintenanceReport || allowMaintenance)) || (showRFIDCol && allowRFIDNeutralization)
  }
  const ActionButtons = ({ obj }) => {
    const { instanceId } = obj
    return (
      <>
        {(showSerialKeyCol && allowMaintenance) && (
          <span
            title={t('inventory:performMaintanance')}
            role='button'
            onClick={(e) => performMaintanance(obj)}
          >
            {<SettingsIcon />}
          </span>
        )}
        {(showSerialKeyCol && allowMaintenanceReport) && (
          <span
            title={t('inventory:maintananceReport')}
            role='button'
            onClick={(e) => loadPdf(instanceId)}
          >
            {!reportIsLoading.reportName ? (
              <PdfIconBtn />
            ) : (
              <Spinner
                as='span'
                animation='border'
                size='sm'
                variant='primary'
                role='status'
              />
            )}
          </span>
        )}
        {(showRFIDCol && allowRFIDNeutralization) ? (
          <>
            {isRemoving ? (
              <span
                className='d-flex justify-content-center'
                style={{ width: '72px' }}
              >
                <Spinner animation='border' variant='primary' />
              </span>
            ) : (
              <StyledRemoveLink to={'#'} onClick={(e) => performRFIDNeutralization(obj)}>
                {t('deleteButton')}
              </StyledRemoveLink>
            )}
          </>
        ) : null}
      </>
    )

  }
  return (
    <>
      <Table borderless striped>
        <thead>
          <tr>
            {showRFIDCol && <th>{t('inventory:scanCode')}</th>}
            {showRFIDCol && <th>{t('inventory:lastScan')}</th>}
            {showSerialKeyCol && <th>{t('inventory:serialNumber')}</th>}
            {showBatchlKeyCol && <th>{t('inventory:batchNumber')}</th>}
            {showWashCol && <th>{t('inventory:washProcess')}</th>}
            {showWashCyclesCol && <th>{t('inventory:washCycles')}</th>}
            {showServiceCol && <th>{t('inventory:maintanance')}</th>}
            {showActionButtons() && <th></th>}
          </tr>
        </thead>
        <tbody>
          {articleInstances.map((obj, i) => (
            <React.Fragment key={`${obj.trackingId}_${obj.instanceId}`}>
              <StyledTr key={`${i}_1`}>
                {showRFIDCol && <td>{obj.rfid}</td>}
                {showRFIDCol && (
                  <td>
                    <LastScan obj={obj} />
                  </td>
                )}
                {showSerialKeyCol && <td>{obj.serialKey && obj.serialKey}</td>}
                {showBatchlKeyCol && <td>{obj.batchKey && obj.batchKey}</td>}
                {showWashCol && (
                  <td>{obj.washCounter != null && obj.washCounter}</td>
                )}
                {showWashCyclesCol && (
                  <td>{obj.washCycles != null && obj.washCycles}</td>
                )}
                {showServiceCol && (
                  <td>
                    <ServiceJob obj={obj} />
                  </td>
                )}
                {(showActionButtons()) && (
                  <td>{<ActionButtons obj={obj} />}</td>
                )}
              </StyledTr>
              {!isEmptyGuid(obj.instanceId) && (
                <tr key={`doc${i}_2`}>
                  <td colSpan='6'>
                    <InstanceDocuments
                      objectId={obj.instanceId}
                      collapsible={true}
                    />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
      {performMaintananceModal && (
        <PerformMaintananceModal
          handleClose={() => {
            setPerformMaintananceModal(false)
          }}
          instance={maintananceInstance}
        />
      )}
    </>
  )
}

const InstancesCard = inject(
  'inventoryStore',
  'uiStore'
)(
  observer((props) => {
    const [openCreateRFIDModal, setOpenCreateRFIDModal] = useState(false)
    const { inventoryStore, uiStore } = props

    const showRFIDCol = useMemo(
      () => inventoryStore.articleInstances.some((instance) => instance.rfid),
      [inventoryStore.articleInstances]
    )
    const useRFID = useMemo(
      () => inventoryStore.articleDetails?.article?.useRFIDs ?? false,
      [inventoryStore.articleDetails]
    )
    const showSerialKeyCol = useMemo(
      () =>
        inventoryStore.articleInstances.some((instance) => instance.serialKey),
      [inventoryStore.articleInstances]
    )

    const showBatchlKeyCol = useMemo(
      () =>
        inventoryStore.articleInstances.some((instance) => instance.batchKey),
      [inventoryStore.articleInstances]
    )
    const showWashCyclesCol = useMemo(() =>
      inventoryStore.articleInstances.some(
        (instance) => instance.washCycles
      )
    , [inventoryStore.articleInstances])
    const showWashCol = useMemo(() => 
      inventoryStore.articleInstances.some(
        (instance) => instance.washCounter
      )
    , [inventoryStore.articleInstances])
    const showServiceCol = useMemo(() => {
      let someLastService = inventoryStore.articleInstances.some(
        (instance) => instance.lastService
      )
      let someNextServiceDate = inventoryStore.articleInstances.some(
        (instance) => !isEmptyDate(instance.nextServiceDate)
      )
      return someLastService || someNextServiceDate
    }, [inventoryStore.articleInstances])

    const getArticleData = () => {
      let clonedArticleDetails = cloneDeep(inventoryStore.articleDetails);
      let template = { instance: null, comment: '' };
      let newPositions = clonedArticleDetails.positions
      for (let p = 0; p < newPositions.length; p++) {
        let variantId = newPositions[p].articleVariant?.id ?? emptyGuid;
        let posInstances = isEmptyGuid(variantId)
          ? inventoryStore.articleInstances
          : inventoryStore.articleInstances.filter(
            (x) => (x.variant?.id ?? emptyGuid) === variantId
          )
        newPositions[p].rows = [];
        let rows = newPositions[p].rows;
        for (let i = 0; i < posInstances.length; i++) {
          let newInstance = cloneDeep(posInstances[i])
          rows.push(cloneDeep(template))
          rows[i].instance = newInstance
        }
        for (let i = rows.length; i < newPositions[p].currentQuantity; i++) {
          rows.push(cloneDeep(template))
        }
      }
      clonedArticleDetails.positions = newPositions;

      return clonedArticleDetails
    }
    const allowRFIDNeutralization = useMemo(
      () => !inventoryStore.articleDetailsIsLoading && !inventoryStore.articleInstancesIsLoading && (inventoryStore.articleInstances.filter((instance) => instance.rfid).length > (inventoryStore.articleDetails?.articleAvailability?.currentAmount ?? 0) || uiStore.allowWashRecapturingScancode),
      [inventoryStore.articleInstances, inventoryStore.articleDetails, inventoryStore.articleDetailsIsLoading, inventoryStore.articleInstancesIsLoading, uiStore.allowWashRecapturingScancode]
    )
    const allowRFIDCreation = useMemo(
      () => !inventoryStore.articleDetailsIsLoading && !inventoryStore.articleInstancesIsLoading && useRFID && (inventoryStore.articleInstances.filter((instance) => instance.rfid).length < (inventoryStore.articleDetails?.articleAvailability?.currentAmount ?? 0) || uiStore.allowWashRecapturingScancode),
      [inventoryStore.articleInstances, inventoryStore.articleDetails, inventoryStore.articleDetailsIsLoading, inventoryStore.articleInstancesIsLoading, useRFID, uiStore.allowWashRecapturingScancode]
    )
    const handleRFIDNeutralization = async (rfid) => {
      if (allowRFIDNeutralization) {
        await inventoryStore.saveRFIDisNeutralizedForEmployee(rfid)
        inventoryStore.loadContingentArticleInstances()
      }
    }
    return (
      <>
        {(showRFIDCol || useRFID) ||
          showSerialKeyCol ||
          showBatchlKeyCol ||
          showWashCol || showWashCyclesCol ||
          showServiceCol ? (
          <StyledCard>
            <StyledFlexWrapper>
              <div className='leftSide'><h1>{t('inventory:instances')}</h1></div>
              {allowRFIDCreation && <div className='rightSide'
                role='button'
                onClick={() => setOpenCreateRFIDModal(true)}
                data-toggle='tooltip'
                data-placement='right'
                title={t('inventory:generateScanCode2')}
              >
                <BiBarcodeReader />
              </div>}
            </StyledFlexWrapper>
            <InstancesTable
              showRFIDCol={showRFIDCol}
              showSerialKeyCol={showSerialKeyCol}
              showBatchlKeyCol={showBatchlKeyCol}
              showWashCol={showWashCol}
              showWashCyclesCol ={showWashCyclesCol}
              showServiceCol={showServiceCol}
              articleInstances={inventoryStore.articleInstances}
              allowMaintenance={uiStore.allowArticleMaintenance}
              allowMaintenanceReport={inventoryStore.allowMaintenanceReport}
              employeeId={inventoryStore.employeeId}
              contingentArticleId={inventoryStore.contingentArticleId}
              handleRFIDNeutralization={handleRFIDNeutralization}
              allowRFIDNeutralization={allowRFIDNeutralization}
            />
          </StyledCard>
        ) : null}
        {openCreateRFIDModal && (
          <CreateRFIDInstance
            article={getArticleData()}
            handleClose={() => {
              setOpenCreateRFIDModal(false)
            }}
            handleUpdateInstances={(result) => { inventoryStore.loadContingentArticleInstances() }}
            disabledAutoGenerator
          />
        )}
      </>
    )
  })
)

export default InstancesCard
